<template>
  <div class="col-box" style="height: 100vh">

    <img src="../assets/ic_bg_top.png" />

    <div style="position: fixed; left: 0; top: 0; right: 0; height: 100%; z-index: 100;">
      <div style="height: 20px;" />
      <div class="player-shell">
        <PlayerFull ref="liveStream" />
      </div>
      <div style="height: 10px;" />
      <!--开闸、关闸、抓拍-->
      <div style="display: flex; flex-direction: row; justify-content: space-between; padding: 0 20px;">
        <div class="col-box-btn" @click="openGate()">
          <img src="../assets/open_gate.png" style="width: 25px;height: 25px; " />
          <span>开闸</span>
        </div>
        <div class="col-box-btn" @click="closeGate()">
          <img src="../assets/close_gate.png" style="width: 25px;height: 25px; " />
          <span>落闸</span>
        </div>
        <div class="col-box-btn" @click="capturePhone()">
          <img src="../assets/capture.png" style="width: 25px;height: 25px; " />
          <span>抓拍</span>
        </div>
      </div>
      <div style="height: 10px;" />
      <div>
        <NavTabs @bindTabItemClickEvent="onClickTabItemEvent">
          <CameraLiveList v-if="activeTabIndex == 0" :roadId="roadId" :videoId="curVideoId"
            @bindSelectVideoItemEvent="onSelectVideoItemEvent" />
          <CameraImageList :parkingId="parkingId" :roadId="roadId" v-if="activeTabIndex == 1" />
          <!-- <CameraLogList :parkingId="parkingId" :roadId="roadId" v-if="activeTabIndex == 2" /> -->
        </NavTabs>
      </div>

    </div>

  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import PlayerFull from "@/components/PlayerFull.vue";
import NavTabs from "@/components/NavTabs.vue";
import CameraLogList from "@/components/listing/CameraLogList.vue";
import CameraLiveList from "@/components/listing/CameraLiveList.vue";
import CameraImageList from "@/components/listing/CameraImageList.vue";
import { CameraVideo } from "@/views/Bean";
import { requestMonitorStream, requestVideoUrl } from "@/api/HttpRequest";
import { showToastSuccess, showToastError } from "@/utils/dialog";
import { requestOpenGate, requestCloseGate, requestCameraCapture } from "@/api/HttpRequest";
import store from "@/stroage/localStorage";

@Options({
  components: {
    PlayerFull,
    NavTabs,
    CameraLogList,
    CameraLiveList,
    CameraImageList
  },
  created() {
    const route = this.$route.query;
    this.roadId = route.roadId;
    // this.roadId = "37716";
    this.parkingId = route.parkingId;
    document.title = route.title || '图片列表'
    store.setToken(route.token);
  },


})
export default class HomeView extends Vue {
  liveStream: any = null;
  parkingId!: string;
  roadId!: string;
  activeTabIndex: number = 0;
  curVideoId = 0;

  onClickTabItemEvent(index: number) {
    this.activeTabIndex = index;
  }
  onSelectVideoItemEvent(data: CameraVideo) {
    // const params = {
    //   equId: data.id,
    // };
    // requestMonitorStream(params, (res: any) => {
    //   if (!res) {
    //     showToastError("未获取到视频");
    //     return;
    //   }
    //   this.curVideoId = data.id;
    //   this.liveStream.playVideoStreamEvent(res);
    // });
    const params = {
      sn: data.code,
      // sn: "7c2f272b-b1ec1532"
    };
    requestVideoUrl(params, (res: any) => {
      if (!res) {
        showToastError("未获取到视频");
        return;
      }
      this.curVideoId = data.id;
      this.liveStream = this.$refs.liveStream as PlayerFull;
      this.liveStream.playVideoStreamEvent(res.videoUrl);
    });

  }

  openGate() {
    const params = {
      roadId: this.roadId,
    };

    requestOpenGate(params, (res: any) => {
      if (res) {
        showToastSuccess("开闸成功");
      }
    });
  }
  closeGate() {
    const params = {
      roadId: this.roadId,
    };

    requestCloseGate(params, (res: any) => {
      if (res) {
        showToastSuccess("关闸成功");
      }
    });
  }
  //抓拍
  capturePhone() {
    const params = {
      roadId: this.roadId,
    };

    requestCameraCapture(params, (res: any) => {
      if (res) {
        showToastSuccess("抓拍成功");
      }
    });
  }
}
</script>
<style scoped>
.col-box-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #6A4DB9;
  color: #6A4DB9;
  padding: 4px 16px;
  border-radius: 6px;
  column-gap: 4px;
}

.col-box-btn:active {
  background-color: #6A4DB9;
  color: white;
}

.player-shell {
  height: clamp(180px, 52vw, 280px);
  margin: 12px;
  padding: 6px;
  border-radius: 10px;
  background-color: rgba(179, 167, 225, 0.9);
  box-sizing: border-box;
}
</style>
